import React, { type PropsWithChildren, memo } from "react";
import clsx from "clsx";
import type { ColorTypes } from "../utils/ColorTypes";
import type { SpacingTypes } from "../utils/SpacingTypes";
import spacingStyles from "../utils/SpacingTypes.module.scss";
import styles from "./Text.module.scss";
import colorStyles from "../utils/ColorTypes.module.scss";

export type Props = {
    tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "div";
    variant?:
        | "apheleia-h1"
        | "apheleia-h2"
        | "apheleia-h3"
        | "apheleia-h4"
        | "apheleia-h5"
        | "apheleia-h6"
        | "apheleia-price"
        | "apheleia-body"
        | "apheleia-body-large"
        | "apheleia-body-small"
        | "apheleia-hybrid-label"
        | "apheleia-list-item"
        | "apheleia-list-item-small"
        | "apheleia-border-title"
        | "apheleia-legal"
        | "apheleia-caption"
        | "header-regular";
    color?: ColorTypes;
    spacing?: SpacingTypes;
    className?: string;
    skeleton?: boolean;
} & React.HTMLProps<HTMLHeadingElement>;

const Text: React.FC<PropsWithChildren<Props>> = (props) => {
    const { tag = "p", variant = "body-book", color, spacing, skeleton, className, children, ...rest } = props;

    return React.createElement(
        tag,
        {
            ...rest,
            className: clsx(
                styles[variant],
                color && colorStyles[color],
                spacing && spacingStyles[spacing],
                skeleton && styles.skeleton,
                className,
            ),
        },
        children,
    );
};

export default memo(Text);
